import { render } from "./NavMenu.vue?vue&type=template&id=575eba22"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"

import "./NavMenu.vue?vue&type=style&index=0&id=575eba22&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "575eba22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('575eba22', script)) {
    api.reload('575eba22', script)
  }
  
  module.hot.accept("./NavMenu.vue?vue&type=template&id=575eba22", () => {
    api.rerender('575eba22', render)
  })

}

script.__file = "src/components/NavMenu.vue"

export default script